export const JBP_PARTNER_BASIC_INFO_CRUD_KEY = 'partner-basic-info'
